import axios from 'axios'

export default {
  namespaced: true,

  state: {
    workClientProjectsPeriodReportGrid: [],
    workClientProjectsPeriodReportShow: {},
    pageData: null,
  },
  getters: {
    workClientProjectsPeriodReportGrid: (state) => {
      return state.workClientProjectsPeriodReportGrid
    },
    workClientProjectsPeriodReportShow: (state) => {
      if (state.workClientProjectsPeriodReportShow !== null) {
        while (typeof state.workClientProjectsPeriodReportShow.data === 'string') {
          state.workClientProjectsPeriodReportShow.data = JSON.parse(
            state.workClientProjectsPeriodReportShow.data,
          )
        }
        if (state.workClientProjectsPeriodReportShow.additional_data) {
          while (typeof state.workClientProjectsPeriodReportShow.additional_data === 'string') {
            state.workClientProjectsPeriodReportShow.additional_data = JSON.parse(
              state.workClientProjectsPeriodReportShow.additional_data,
            )
          }
        }
      }
      return state.workClientProjectsPeriodReportShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  mutations: {
    setWorkClientProjectsPeriodReportGrid(state, payload) {
      state.workClientProjectsPeriodReportGrid = payload
    },
    setWorkClientProjectsPeriodReportShow(state, payload) {
      state.workClientProjectsPeriodReportShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  actions: {
    onWorkClientProjectsPeriodReportGrid({commit, rootState}, {limit, page, project_id, sort, period}) {
      let url =
        rootState.apiDomain +
        '/api/admin/work/client/project/period-report/' +
        project_id +
        '/reports-grid?limit=' +
        limit +
        '&page=' +
        page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=created_at:desc'
      }
      // if (project_id) {
      //   url = url + '&filter[]=project_id:' + project_id
      // }
      if (period && period.length > 0) url = url + '&start=' + period[0] + '&end=' + period[1]
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsPeriodReportGrid', resp.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportShow({commit, rootState}, id) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            commit('setWorkClientProjectsPeriodReportShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportShowAdditional({commit, rootState}, {id, data}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/' + id,
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            //commit('setWorkClientProjectsPeriodReportShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportCreate({rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodUpdate({rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/period',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportDelete({rootState}, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportSign({rootState}, {id, data}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/sign/' + id,
          data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportUnsign({rootState}, {id}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/unsign/' + id,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportRefresh({rootState}, {id}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/refresh/' + id,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsPeriodReportSend({rootState}, {id, data}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/period-report/send/' + id,
          method: 'POST',
          data: data,
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
